// The BibTeX is parsed at build time by scripts/build-bibliography.js, so the browser receives
// the finished data instead of the parser plus 140 KB of BibTeX to chew on at every visit.
import groupedByYear from "../../generated/publications.json";

export default groupedByYear;
